"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
const client_fetch_1 = require("@hey-api/client-fetch");
exports.client = (0, client_fetch_1.createClient)((0, client_fetch_1.createConfig)());
